import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';

// Asset Imports
import socialHero from './socialmedia.webp'; 
import igIcon from './instagram.png';
import metaIcon from './facebook.png'; 
import linkedinIcon from './linkedin.png';

const SocialMediaMarketingPage = () => {
  return (
    <div style={styles.container}>
      <Helmet>
        <title>Social Media Marketing Services Chennai | BMF</title>
        <meta name="description" content="Strategic social media marketing by BMF Chennai. Meta, Instagram & LinkedIn campaigns with cinematic content production that builds authority & drives revenue." />
        <meta name="keywords" content="social media marketing Chennai, Instagram marketing Tamil Nadu, Facebook advertising Chennai, LinkedIn marketing, content marketing agency BMF" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Social Media Marketing Services Chennai | BMF" />
        <meta property="og:description" content="Beyond vanity metrics — BMF engineers high-authority social ecosystems on Meta & LinkedIn that command respect and drive revenue." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://brandingmediafactory.com/services/social-media-marketing" />
      </Helmet>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');
          
          @keyframes reveal {
            from { opacity: 0; transform: translateY(40px) scale(0.98); }
            to { opacity: 1; transform: translateY(0) scale(1); }
          }
          .reveal { animation: reveal 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

          .bento-card {
            background: rgba(255,255,255,0.03);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255,255,255,0.1);
            transition: all 0.4s ease;
          }
          .bento-card:hover {
            background: rgba(255,255,255,0.07);
            border-color: #3b82f6;
            transform: translateY(-5px);
          }
          .nav-glass {
            background: rgba(255,255,255,0.8);
            backdrop-filter: blur(12px);
            -webkit-backdrop-filter: blur(12px);
          }
          .text-gradient {
            background: linear-gradient(135deg, #fff 0%, #94a3b8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          @media (max-width: 768px) {
            /* Hero */
            .hero-title { font-size: clamp(2rem, 9vw, 3rem) !important; letter-spacing: -0.03em !important; }
            .hero-subtitle { font-size: 0.95rem !important; margin: 16px auto !important; }
            .hero-badge { font-size: 9px !important; letter-spacing: 2px !important; }
            .btn-primary-hero { padding: 14px 28px !important; font-size: 0.9rem !important; }

            /* Bento grid */
            .bento-grid { grid-template-columns: 1fr !important; gap: 12px !important; }
            .bento-span { grid-column: span 1 !important; }
            .bento-card { padding: 24px !important; border-radius: 20px !important; }
            .card-title { font-size: 1.1rem !important; }
            .tag-group { flex-wrap: wrap !important; gap: 6px !important; }

            /* Section headings */
            .section-heading { font-size: clamp(1.6rem, 6vw, 2.2rem) !important; }
            .section-sub { font-size: 0.9rem !important; }
            .section-wrap { padding: 50px 18px !important; }

            /* Stats */
            .stats-row { flex-direction: column !important; gap: 32px !important; padding: 60px 20px !important; }
            .stat-divider { display: none !important; }
            .stat-num { font-size: clamp(2.2rem, 8vw, 3.5rem) !important; }

            /* Roadmap */
            .process-wrap { flex-direction: column !important; gap: 0 !important; margin-top: 24px !important; }
            .process-line { display: none !important; }
            .process-step {
              flex: unset !important;
              width: 100% !important;
              text-align: left !important;
              border-left: 4px solid #3b82f6 !important;
              background: #f8fafc !important;
              border-radius: 0 12px 12px 0 !important;
              padding: 18px 20px !important;
              margin-bottom: 10px !important;
              box-sizing: border-box !important;
            }
            .step-circle { margin: 0 0 10px 0 !important; width: 44px !important; height: 44px !important; font-size: 16px !important; }
            .step-title { font-size: 1rem !important; }
            .step-text { font-size: 0.88rem !important; }
            .pre-heading { font-size: 10px !important; }
          }
        `}
      </style>

      {/* NAV */}
      <div className="nav-glass" style={styles.headerWrapper}>
        <Header />
      </div>

      {/* HERO */}
      <section style={styles.hero}>
        <img src={socialHero} alt="Social Media Hero" style={styles.heroBgImg} />
        <div style={styles.heroOverlay}></div>
        <div style={styles.heroContent} className="reveal">
          <div className="hero-badge" style={styles.heroBadge}>THE NEW STANDARD OF SOCIAL</div>
          <h1 className="hero-title text-gradient" style={styles.heroTitle}>
            We Build Digital <br />
            <span style={styles.blueAccent}>Legacies.</span>
          </h1>
          <p className="hero-subtitle" style={styles.heroSubtitle}>
            Moving beyond vanity metrics. We engineer high-authority social ecosystems for Meta and LinkedIn that command respect and drive revenue.
          </p>
          <div style={styles.heroActions}>
            <Link to="/contact">
              <button className="btn-primary-hero" style={styles.btnPrimary}>Start Your Growth Phase</button>
            </Link>
            <div style={styles.trustedBy}>
              <span style={{ color: '#64748b', fontSize: '12px', letterSpacing: '1px' }}>TRUSTED BY INNOVATORS WORLDWIDE</span>
            </div>
          </div>
        </div>
      </section>

      {/* METHODOLOGY */}
      <section className="section-wrap" style={styles.section}>
        <div style={styles.centered}>
          <h2 className="section-heading" style={styles.sectionHeading}>Our Methodology</h2>
          <p className="section-sub" style={styles.sectionSub}>Precision-engineered growth across the three pillars of social dominance.</p>
        </div>

        <div className="bento-grid" style={styles.bentoGrid}>
          <div className="bento-card bento-span" style={{ ...styles.bentoItem, gridColumn: 'span 2' }}>
            <div style={styles.iconBox}><img src={metaIcon} width="30" alt="Meta" /></div>
            <h3 className="card-title" style={styles.cardTitle}>Meta Full-Funnel Mastery</h3>
            <p style={styles.cardText}>From cinematic Instagram Reels to data-driven Facebook community management. We don't just "post"—we architect a journey from first impression to brand loyalty.</p>
            <div className="tag-group" style={styles.tagGroup}>
              <span style={styles.tag}>Content Pillars</span>
              <span style={styles.tag}>Community Care</span>
              <span style={styles.tag}>Paid Integration</span>
            </div>
          </div>

          <div className="bento-card" style={styles.bentoItem}>
            <div style={styles.iconBox}><img src={linkedinIcon} width="30" alt="LinkedIn" /></div>
            <h3 className="card-title" style={styles.cardTitle}>LinkedIn Authority</h3>
            <p style={styles.cardText}>B2B positioning for executives and high-growth firms.</p>
            <ul style={styles.miniList}>
              <li>• Executive Ghostwriting</li>
              <li>• Thought Leadership</li>
              <li>• Industry Networking</li>
            </ul>
          </div>

          <div className="bento-card" style={styles.bentoItem}>
            <h3 className="card-title" style={styles.cardTitle}>Real-Time Insights</h3>
            <p style={styles.cardText}>Transparent dashboards showing the metrics that actually matter: ROI and Sentiment.</p>
          </div>

          <div className="bento-card bento-span" style={{ ...styles.bentoItem, gridColumn: 'span 2' }}>
            <h3 className="card-title" style={styles.cardTitle}>Cinematic Content Production</h3>
            <p style={styles.cardText}>Our in-house studio produces 4K short-form video content specifically designed to trigger the latest platform algorithms and maximize organic reach.</p>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section style={styles.darkSection}>
        <div className="stats-row" style={styles.statsRow}>
          <div style={styles.statBox}>
            <h4 className="stat-num" style={styles.statNum}>12M+</h4>
            <p style={styles.statLabel}>Impressions Managed</p>
          </div>
          <div className="stat-divider" style={styles.divider}></div>
          <div style={styles.statBox}>
            <h4 className="stat-num" style={styles.statNum}>340%</h4>
            <p style={styles.statLabel}>Avg. Engagement Lift</p>
          </div>
          <div className="stat-divider" style={styles.divider}></div>
          <div style={styles.statBox}>
            <h4 className="stat-num" style={styles.statNum}>15:1</h4>
            <p style={styles.statLabel}>Creative ROI</p>
          </div>
        </div>
      </section>

      {/* ROADMAP */}
      <section className="section-wrap" style={styles.section}>
        <div style={styles.centered}>
          <span className="pre-heading" style={styles.preHeading}>THE ROADMAP</span>
          <h2 className="section-heading" style={styles.sectionHeading}>How We Scale You</h2>
        </div>

        <div className="process-wrap" style={styles.processContainer}>
          <div className="process-step" style={styles.processStep}>
            <div className="step-circle" style={styles.stepCircle}>1</div>
            <h4 className="step-title" style={styles.stepTitle}>Deep Audit</h4>
            <p className="step-text" style={styles.stepText}>We analyze your competitors, your voice, and your missed opportunities.</p>
          </div>
          <div className="process-line" style={styles.processLine}></div>
          <div className="process-step" style={styles.processStep}>
            <div className="step-circle" style={styles.stepCircle}>2</div>
            <h4 className="step-title" style={styles.stepTitle}>Deployment</h4>
            <p className="step-text" style={styles.stepText}>High-cadence content scheduling across your primary growth channels.</p>
          </div>
          <div className="process-line" style={styles.processLine}></div>
          <div className="process-step" style={styles.processStep}>
            <div className="step-circle" style={styles.stepCircle}>3</div>
            <h4 className="step-title" style={styles.stepTitle}>Optimization</h4>
            <p className="step-text" style={styles.stepText}>Bi-weekly strategy pivots based on real audience data and trends.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

const styles = {
  container: { backgroundColor: '#ffffff', fontFamily: "'Plus Jakarta Sans', sans-serif", overflowX: 'hidden', width: '100%' },
  headerWrapper: { position: 'fixed', top: 0, width: '100%', zIndex: 1000, borderBottom: '1px solid #f1f5f9' },

  // HERO
  hero: { position: 'relative', minHeight: '95vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#020617', textAlign: 'center', overflow: 'hidden', paddingTop: '80px' },
  heroBgImg: { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.5 },
  heroOverlay: { position: 'absolute', inset: 0, background: 'radial-gradient(circle at center, transparent 100%, #020617 80%)' },
  heroContent: { position: 'relative', zIndex: 5, padding: '0 20px', maxWidth: '800px' },
  heroBadge: { color: 'white', fontSize: '11px', fontWeight: '600', letterSpacing: '4px', marginBottom: '20px' },
  heroTitle: { fontSize: 'clamp(2.2rem, 8vw, 5rem)', fontWeight: '800', lineHeight: '1.1', letterSpacing: '-0.04em' },
  blueAccent: { color: '#3b82f6' },
  heroSubtitle: { color: 'white', fontSize: '1.1rem', maxWidth: '600px', margin: '30px auto', lineHeight: '1.6' },
  heroActions: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px', marginTop: '10px' },
  btnPrimary: { padding: '18px 36px', backgroundColor: '#3b82f6', color: '#fff', border: 'none', borderRadius: '100px', fontWeight: '700', cursor: 'pointer', transition: '0.3s', fontSize: '1rem' },
  trustedBy: { marginTop: '4px' },

  // SECTIONS
  section: { padding: 'clamp(50px, 8vw, 120px) clamp(16px, 5%, 60px)', maxWidth: '1300px', margin: '0 auto' },
  centered: { textAlign: 'center', marginBottom: '40px', padding: '0 10px' },
  sectionHeading: { fontSize: 'clamp(1.6rem, 5vw, 3.5rem)', fontWeight: '800', letterSpacing: '-0.02em', color: '#0f172a' },
  sectionSub: { color: '#64748b', fontSize: 'clamp(0.9rem, 2.5vw, 1.2rem)', marginTop: '10px' },

  // BENTO GRID
  bentoGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' },
  bentoItem: { padding: '40px', borderRadius: '32px', backgroundColor: '#f8fafc', border: '1px solid #e2e8f0' },
  iconBox: { marginBottom: '25px', width: '50px', height: '50px', backgroundColor: '#fff', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' },
  cardTitle: { fontSize: 'clamp(1rem, 3vw, 1.5rem)', fontWeight: '700', color: '#0f172a', marginBottom: '15px' },
  cardText: { color: '#64748b', lineHeight: '1.7', fontSize: 'clamp(0.85rem, 2vw, 1rem)' },
  tagGroup: { display: 'flex', gap: '10px', marginTop: '20px', flexWrap: 'wrap' },
  tag: { fontSize: '11px', fontWeight: '700', padding: '5px 12px', background: '#eff6ff', color: '#3b82f6', borderRadius: '50px' },
  miniList: { listStyle: 'none', padding: 0, marginTop: '15px', color: '#64748b', fontSize: '14px' },

  // STATS
  darkSection: { backgroundColor: '#020617', padding: 'clamp(50px, 8vw, 100px) 5%' },
  statsRow: { maxWidth: '1100px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  statBox: { textAlign: 'center' },
  statNum: { fontSize: 'clamp(2.2rem, 7vw, 4rem)', fontWeight: '800', color: '#fff', margin: 0 },
  statLabel: { color: '#3b82f6', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', fontSize: '12px', marginTop: '10px' },
  divider: { height: '80px', width: '1px', background: 'rgba(255,255,255,0.1)' },

  // PROCESS
  preHeading: { color: '#3b82f6', fontWeight: '800', fontSize: '12px', letterSpacing: '3px', display: 'block', marginBottom: '8px' },
  processContainer: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginTop: '40px' },
  processStep: { flex: 1, textAlign: 'center', padding: '0 20px' },
  stepCircle: { width: '60px', height: '60px', backgroundColor: '#0f172a', color: '#fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto', fontSize: '20px', fontWeight: '800' },
  processLine: { flex: 0.5, height: '2px', background: '#f1f5f9', marginTop: '30px' },
  stepTitle: { fontSize: 'clamp(1rem, 3vw, 1.4rem)', fontWeight: '700', marginBottom: '10px' },
  stepText: { color: '#64748b', lineHeight: '1.6', fontSize: 'clamp(0.85rem, 2vw, 1rem)' },
};

export default SocialMediaMarketingPage;